import api from '@/services/api';

interface PipelineData {
  name: string;
  pipeline_type: string;
  params: {
    num_designs: number;
    temperature: number;
    num_to_build: string;
    num_structures: number;
  };
  input_pdb: string;
}

export const createPipeline = async (data: PipelineData) => {
  try {
    const response = await api.post('/api/pipelines/', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating pipeline:', error);
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('Failed to create pipeline');
  }
};

export const getPipelines = async () => {
  try {
    const response = await api.get('/api/pipelines/');
    return response.data;
  } catch (error) {
    console.error('Error fetching pipelines:', error);
    throw error;
  }
};

export const getPipeline = async (id: string) => {
  try {
    const response = await api.get(`/api/pipelines/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching pipeline ${id}:`, error);
    throw error;
  }
};

export const deletePipeline = async (id: string) => {
  try {
    await api.delete(`/api/pipelines/${id}/`);
  } catch (error) {
    console.error(`Error deleting pipeline ${id}:`, error);
    throw error;
  }
}; 